/**
 * Парсит содержимое .lrc файла в массив объектов для караоке.
 * Формат строки: [mm:ss.xx] Текст
 */
export const parseLRC = (lrcContent) => {
    if (!lrcContent) return [];

    // Очистка от возможных артефактов загрузки (например, если пришел HTML вместо текста)
    if (lrcContent.trim().startsWith('<!DOCTYPE')) return [];

    const lines = lrcContent.split(/\r?\n/);
    const lyrics = [];
    // Более универсальный regex для времени: [mm:ss.xx] или [mm:ss:xx] или [mm:ss]
    const timeRegex = /\[(\d{1,2}):(\d{1,2})(?:[:.](\d{1,3}))?\]/;

    lines.forEach(line => {
        const match = timeRegex.exec(line);
        if (match) {
            // Игнорируем мета-теги [ti:...] [ar:...]
            if (line.match(/^\[[a-z]{2}:/i)) return;

            const minutes = parseInt(match[1]);
            const seconds = parseInt(match[2]);
            const msRaw = match[3] || "0";
            const milliseconds = parseInt(msRaw);

            // Преобразуем в секунды (учитываем разную длину ms)
            const msFactor = msRaw.length === 3 ? 1000 : 100;
            let time = minutes * 60 + seconds + (milliseconds / msFactor);

            // Опережение на 200мс для лучшей синхронизации (визуальное восприятие)
            time = Math.max(0, time - 0.28);

            const text = line.replace(timeRegex, '').trim();

            if (text) {
                lyrics.push({ time, text });
            }
        }
    });

    return lyrics.sort((a, b) => a.time - b.time);
};
